export default class AbstractFilterDefinition
{
    constructor(name, label) {
        if (this.constructor === AbstractFilterDefinition) {
            throw new Error('Abstract class "AbstractFilterDefinition" cannot be instantiated directly');
        }

        this.name = name;
        this.label = label;
        this.data = null;
        this.metas = {};
        this.group = null;
    }

    /**
     * Return component name
     */
    get component() {
        throw new Error('You must implement this function');
    }

    /**
     * Format filter data for api
     */
    dataAdapter(data) {
        throw new Error('You must implement this function');
    }

    /**
     * Set filter group
     * @param group
     * @returns {AbstractFilterDefinition}
     */
    setGroup(group) {
        this.group = group;
        return this;
    }

    /**
     * Return component configuration
     */
    get configuration() {
        return {};
    }


    /**
     * Return filters configuration
     */
    build() {
        return {
            name: this.name,
            label: this.label,
            component: this.component,
            inputs: this.configuration,
            active: false,
            pending: false,
            data: [],
            translation: "",
            keywords: "",
            customfield: false,
            deletable: true,
            customfieldcategory: "",
            topscore: false,
            definition: this,
            group: this.group
        };
    }
}